// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"882e7a8b","239":"06d34b47","455":"2e5a0d14"}[chunkId] + ".chunk.js";
};